export function ConsultCTA({ onConsult }) {
    return (
        <section className="px-5 pb-24 lg:px-8" data-testid="footer-cta">
            <div className="si-navy-band reveal relative mx-auto max-w-7xl overflow-hidden rounded-[32px] px-8 py-16 text-white sm:px-14 lg:py-24">
                <img src="https://images.unsplash.com/photo-1554208791-ff69f8454d1b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600" alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-50" aria-hidden="true" />
                <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/60 to-navy/90" aria-hidden="true" />
                <div className="si-navy-glow" aria-hidden="true" />
                <div className="relative mx-auto flex max-w-3xl flex-col items-center gap-8 text-center">
                    <div>
                        <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-[-0.035em] sm:text-5xl">Ready to make the <span className="font-serif-accent text-teal-light">smarter choice?</span></h2>
                        <p className="mt-4 text-lg text-slate-300">Tell us what you're building. A free consultation confirms the right service, scope, and fee — in writing — before anything is signed.</p>
                    </div>
                    <button onClick={onConsult} data-testid="footer-cta-consult" className="si-btn-primary shrink-0">Book a free consultation</button>
                </div>
            </div>
        </section>
    );
}
